/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { DefaultTheme } from 'styled-components/native'

import { LinkSize } from './types'

const gapBySize = ({ theme }: { theme: DefaultTheme }): Record<LinkSize, number> => ({
  default: theme.designSystem.size.spacing.s,
  small: theme.designSystem.size.spacing.xs,
  extraSmall: theme.designSystem.size.spacing.xs,
})

export const getLinkGap = ({ size, theme }: { size: LinkSize; theme: DefaultTheme }) =>
  gapBySize({ theme })[size]
